import React from "react";
// Common Components
import { DynamicDropdown, Button, DatePicker } from "src/Components";
import { WrappedTimeSeriesChart } from "src/Components/Timeseries/WrappedTimeSeriesChart";
import ChartSkeleton from "src/Components/Charts/ChartSkeleton";
// Requests
import { getConversionGraph } from "src/Requests/coveredCall";
import { getBaseInstruments } from "src/Requests/Order/tradeTableRequests";
// Utilities
import moment from "moment";
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { IConversionConfig, IChartData } from "src/Interfaces/coveredCall";

const CoversionModal: React.FC = () => {
  const [dataSet, setDataSet] = React.useState<IChartData[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [searchParam, setSearchParam] = React.useState<IConversionConfig>({
    toDate: moment().format("YYYY-MM-DD"),
    fromDate: moment().add(-7, "days").format("YYYY-MM-DD"),
  } as IConversionConfig);

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  const onSubmit = () => {
    setLoading(true);
    getConversionGraph(searchParam)
      .then((data) => {
        setDataSet(data);
      })
      .catch((error) => {
        setDataSet([]);
        packetErrorHandler(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="flex h-full w-full min-h-0 gap-2">
      <div className="flex flex-col gap-4 w-60 shrink-0">
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "baseInstrumentId",
              placeholder: "نوع پایه",
              extraLabel: true,
            }}
            getData={() => getBaseInstruments()}
            onChange={searchParamChangeHandler}
            value={searchParam?.baseInstrumentId}
          />
        </div>
        <div className="flex justify-start items-start gap-3">
          <DatePicker
            label="از تاریخ"
            name="fromDate"
            onChange={searchParamChangeHandler}
            value={searchParam?.fromDate}
          />
          <DatePicker
            label="تا تاریخ"
            name="toDate"
            onChange={searchParamChangeHandler}
            value={searchParam?.toDate}
          />
        </div>
        <div className="flex gap-3">
          <Button
            onClick={() => {
              setSearchParam({
                ...searchParam,
                toDate: moment().format("YYYY-MM-DD"),
                fromDate: moment().add(-7, "days").format("YYYY-MM-DD"),
              });
            }}
            text="۷ روزه"
            variant={
              searchParam?.fromDate ===
              moment().add(-7, "days").format("YYYY-MM-DD")
                ? "contained"
                : "outlined"
            }
            className="table-btn"
          />
          <Button
            onClick={() => {
              setSearchParam({
                ...searchParam,
                toDate: moment().format("YYYY-MM-DD"),
                fromDate: moment().add(-30, "days").format("YYYY-MM-DD"),
              });
            }}
            text="۳۰ روزه"
            variant={
              searchParam?.fromDate ===
              moment().add(-30, "days").format("YYYY-MM-DD")
                ? "contained"
                : "outlined"
            }
            className="table-btn"
          />
          <Button
            onClick={() => {
              setSearchParam({
                ...searchParam,
                toDate: moment().format("YYYY-MM-DD"),
                fromDate: moment().add(-90, "days").format("YYYY-MM-DD"),
              });
            }}
            text="۹۰ روزه"
            variant={
              searchParam?.fromDate ===
              moment().add(-90, "days").format("YYYY-MM-DD")
                ? "contained"
                : "outlined"
            }
            className="table-btn"
          />
        </div>
        <Button
          onClick={onSubmit}
          text="جستجو"
          variant="contained"
          disabled={loading}
        />
      </div>
      <div className="chart-fill-modal">
        {loading ? (
          <ChartSkeleton className="w-full" height={400} />
        ) : (
          <WrappedTimeSeriesChart
            dataset={dataSet}
            withDate
            className="h-full w-full"
          />
        )}
      </div>
    </div>
  );
};

export default CoversionModal;
